import { Hourglass, Layers } from "lucide-react";
import Panel, { Empty } from "./Panel";
import { PipelineBar, formatINR } from "../../../components/dashboard/shared";

// My open leads by stage, with the deals that have stopped moving underneath.
const MyPipeline = ({ pipeline, stuck, loading, onOpen, onViewAll }) => {
    const total = (pipeline || []).reduce((s, p) => s + p.count, 0);
    return (
        <Panel title="My pipeline" icon={Layers} loading={loading} action="My leads" onAction={onViewAll}>
            {!total ? (
                <Empty icon={Layers} title="No open leads assigned to you"
                       hint="Pick some up from the unassigned pool." />
            ) : (
                <>
                    {pipeline.map(p => (
                        <PipelineBar key={p.stage} stage={p.stage} count={p.count} total={total}
                            right={<span className="text-[11px] text-gray-400 w-14 text-right tabular-nums">{p.value ? formatINR(p.value) : ""}</span>} />
                    ))}
                    {stuck?.length > 0 && (
                        <div className="mt-3 pt-3 border-t border-gray-100 dark:border-gray-700">
                            <p className="flex items-center gap-1.5 text-xs font-semibold text-gray-700 dark:text-gray-200 mb-1.5">
                                <Hourglass className="h-3.5 w-3.5 text-amber-500" /> Stuck deals
                            </p>
                            <ul className="space-y-1">
                                {stuck.map(s => (
                                    <li key={s.customer_id} onClick={() => onOpen(s.customer_id)}
                                        className="flex items-center justify-between gap-2 text-xs p-1.5 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700/40 cursor-pointer">
                                        <span className="truncate text-gray-800 dark:text-gray-200">{s.customer_name}</span>
                                        <span className="text-gray-500 dark:text-gray-400 whitespace-nowrap">
                                            {s.lead_stage} · {s.days}d
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </>
            )}
        </Panel>
    );
};

export default MyPipeline;
